// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"92c4ad41","496":"f38ab614"}[chunkId] + ".chunk.js";
};